import { set } from 'lodash-es';
import {
  ADJUSTED_GROSS_INCOME_LOCAL_QUESTION_ID,
  ADJUSTED_GROSS_INCOME_FEDERAL_QUESTION_ID,
  FIRST_TIME_BUYER_QUESTION_ID,
  HOUSEHOLD_SIZE_QUESTION_ID,
  PARTICIPATE_IN_QUALITY_PROGRAMS_QUESTION_ID,
  RESIDE_DISADVANTAGE_COMMUNITY_QUESTION_ID,
  TAX_FILING_STATUS_LOCAL_QUESTION_ID,
  TAX_FILING_STATUS_FEDERAL_QUESTION_ID,
  RETIREMENT_QUESTION_ID,
  RIDESHARE_QUESTION_ID,
} from 'site-modules/shared/components/incentives/incentives-wizard/questions/questions';
import { getQualifierMapper } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/qualifier-mapper-factory';

const QUESTIONS_ELIGIBILITY_FACTOR_FIELD_MAP = {
  [ADJUSTED_GROSS_INCOME_FEDERAL_QUESTION_ID]: 'income',
  [ADJUSTED_GROSS_INCOME_LOCAL_QUESTION_ID]: 'income',
  [TAX_FILING_STATUS_FEDERAL_QUESTION_ID]: 'taxFilingStatus',
  [TAX_FILING_STATUS_LOCAL_QUESTION_ID]: 'taxFilingStatus',
  [HOUSEHOLD_SIZE_QUESTION_ID]: 'householdSize',
  [FIRST_TIME_BUYER_QUESTION_ID]: 'assistanceParticipant',
  [PARTICIPATE_IN_QUALITY_PROGRAMS_QUESTION_ID]: 'assistanceParticipant',
  [RESIDE_DISADVANTAGE_COMMUNITY_QUESTION_ID]: 'assistanceParticipant',
  [RETIREMENT_QUESTION_ID]: 'assistanceParticipant',
  [RIDESHARE_QUESTION_ID]: 'assistanceParticipant',
};

const assistanceParticipantHandler = (multiQualifier, answers) => {
  const qualifierList = multiQualifier
    .toLowerCase()
    .split(';')
    .filter(qualifier => !!getQualifierMapper(qualifier)('assistanceParticipant'));

  const assistanceParticipantAnswers = qualifierList.reduce((acc, qualifier) => {
    const questionId = getQualifierMapper(qualifier)('assistanceParticipant')[0];

    return Object.hasOwn(answers, questionId) ? [...acc, answers[questionId][0]] : acc;
  }, []);

  if (!assistanceParticipantAnswers.length) {
    return false;
  }

  return assistanceParticipantAnswers.every(answer => !!answer);
};

export function createEligibilityFactorFilter(state) {
  const { eligibilityQuestionsQualifiersMap, answers } = state;
  const filter = {};
  Object.entries(eligibilityQuestionsQualifiersMap).forEach(([questionId, qualifiersList]) => {
    qualifiersList.forEach(qualifier => {
      const field = QUESTIONS_ELIGIBILITY_FACTOR_FIELD_MAP[questionId];
      if (field === 'assistanceParticipant' && qualifier.includes(';')) {
        const answer = assistanceParticipantHandler(qualifier, answers);
        set(filter, `${qualifier}.${field}`, answer);
        return;
      }
      if (Object.hasOwn(answers, questionId)) {
        const answer = answers[questionId][0];
        set(filter, `${qualifier}.${field}`, answer);
      }
    });
  });

  return Object.entries(filter).map(([qualifier, fields]) => ({ qualifier, ...fields }));
}
